(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdf-reader", [], factory);
	else if(typeof exports === 'object')
		exports["pdf-reader"] = factory();
	else
		root["pdf-reader"] = factory();
})(self, () => {
return 